









































































































































































import {
  IVacationCarryOverRequest,
  VacationCarryOverRequest,
  VacationCarryOverRequestFieldError,
  IVacationCarryOverRequestData,
  EmployeeType,
  IEmployee,
  IHrDepartment
} from '@/models';

import { ALForm } from '@/common/component.types';

import { ErrorManager } from '@/models/error';

import ErrorAlert from '../common/ErrorAlert.vue';
import { diffDeep } from '@/utils/helpers';
import { mapActions, mapGetters } from 'vuex';

import auth from '@/mixins/auth';
import mixins from '@/utils/mixins';

import moment from 'moment';
import { cloneDeep } from 'lodash';
import { AxiosError } from 'axios';

import DatePicker from '../common/DatePicker.vue';
import RenderlessDragAndDrop from '../common/RenderlessDragAndDrop.vue';
import TimePicker from '../common/TimePicker.vue';
import EmployeePicker from '../employee/EmployeePicker.vue';
import HRDepartmentPicker from '../employee/hr/HRDepartmentPicker.vue';
import VDragDropFileInput from '../common/VDragDropFileInput.vue';

const baseMixins = mixins(auth);

export interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    form: ALForm;
  };
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'VacationCarryOverRequestDetailForm',

    components: {
      ErrorAlert,
      DatePicker,
      RenderlessDragAndDrop,
      TimePicker,
      EmployeePicker,
      HRDepartmentPicker,
      VDragDropFileInput
    },

    data() {
      return {
        EmployeeType,
        dialog: false,
        formValid: false,
        isEdit: false,
        loading: false,

        vacationCarryOverRequest: {} as IVacationCarryOverRequest,

        fieldError: new VacationCarryOverRequestFieldError(),

        errorMessage: '',
        errorMessageDetail: '',

        requiredRules: [(v: any) => !!v || 'This field is required'],
        amountRequestedRules: [
          (v: any) => v > 0 || 'Amount requested must be greater than 0'
        ],

        employeeDepartment: null as IHrDepartment | null,
        employeeSupervisor: ''
      };
    },

    computed: {
      ...mapGetters({
        getVacationCarryOverRequestById:
          'vacationCarryOverRequest/getVacationCarryOverRequestById',
        getEmployeeTimeOffEntitlementVacationYear:
          'employeeTimeOff/getEmployeeTimeOffEntitlementVacationYear',
        getEmployeeById: 'employee/getEmployeeById'
      }),

      entitlementToYear(): number {
        return this.getEmployeeTimeOffEntitlementVacationYear
          ? this.getEmployeeTimeOffEntitlementVacationYear + 1
          : moment().get('year');
      },

      entitlementYearList(): number[] {
        const yearList = [this.entitlementToYear];
        if (this.canEditEmployee) {
          // only HR can create exceptions for previous years
          yearList.unshift(this.entitlementToYear - 1);
        }
        return yearList;
      },

      canEditEmployee(): boolean {
        return !this.isEdit && this.isUserHRPersonnel;
      }
    },

    methods: {
      moment,
      ...mapActions({
        createVacationCarryOverRequest:
          'vacationCarryOverRequest/createVacationCarryOverRequest',
        updateVacationCarryOverRequest:
          'vacationCarryOverRequest/updateVacationCarryOverRequest',
        deleteVacationCarryOverAttachment:
          'vacationCarryOverRequest/deleteVacationCarryOverAttachment',
        fetchEmployeeTimeOffEntitlementVacationYear:
          'employeeTimeOff/fetchEmployeeTimeOffEntitlementVacationYear',
        fetchEmployee: 'employee/fetchEmployee'
      }),

      resetFormValidation(): void {
        if (this.$refs.form) {
          return this.$refs.form.resetValidation();
        }
      },

      validateForm(): boolean {
        let valid = false;
        if (this.$refs.form) {
          valid = this.$refs.form.validate();
        }
        return valid;
      },

      clearVacationCarryOverRequestEmployee() {
        this.employeeDepartment = null;
        this.employeeSupervisor = '';
      },

      async updateVacationCarryOverRequestEmployeeHandler(employeeId?: number) {
        this.clearAllErrors();
        if (employeeId) {
          const employee = await this.tryGetOrFetchEmployee(employeeId);

          this.employeeDepartment = employee.hr_department as IHrDepartment | null;

          if (
            this.canEditEmployee &&
            this.currentUser.employee !== employeeId
          ) {
            this.employeeSupervisor = this.getCurrentUserFullName.concat(
              '(HR)'
            );
          } else {
            // not every employee has supervisor
            this.employeeSupervisor =
              (employee.supervisor as IEmployee)?.fullName ?? '';
          }

          this.vacationCarryOverRequest.employee = employeeId;

          const entitlementYear = await this.tryGetOrFetchEmployeeTimeOffEntitlementVacationYear(
            employeeId
          );

          if (entitlementYear) {
            this.vacationCarryOverRequest.year = entitlementYear + 1;
          }
        }
      },

      async open(vacationCarryOverRequest?: IVacationCarryOverRequestData) {
        this.vacationCarryOverRequest = new VacationCarryOverRequest({
          reason: '',
          approvers: [],
          amount_requested: 0,
          year: moment().get('year')
        });

        if (vacationCarryOverRequest) {
          this.vacationCarryOverRequest = new VacationCarryOverRequest(
            vacationCarryOverRequest
          );
        }

        this.updateVacationCarryOverRequestEmployeeHandler(
          this.currentUser.employee
        );

        this.isEdit = !!vacationCarryOverRequest;

        this.clearAllErrors();

        this.dialog = true;

        this.resetFormValidation();
      },

      async tryGetOrFetchEmployee(employeeId: number): Promise<IEmployee> {
        if (!this.getEmployeeById(employeeId)) {
          await this.fetchEmployee(employeeId);
        }
        return this.getEmployeeById(employeeId);
      },

      async tryGetOrFetchEmployeeTimeOffEntitlementVacationYear(
        employeeId: number
      ): Promise<number> {
        if (!this.getEmployeeTimeOffEntitlementVacationYear) {
          await this.fetchEmployeeTimeOffEntitlementVacationYear(
            employeeId
          ).catch(error => {
            if (error.response && error.response.data.detail) {
              // display year error specifically on year field
              this.fieldError.year.push(error.response.data.detail);
            } else {
              this.fieldError.year.push('Error retrieving entitlement year');
            }
          });
        }
        return this.getEmployeeTimeOffEntitlementVacationYear;
      },

      clearAllErrors(): void {
        this.fieldError.clearErrors();
        this.errorMessage = '';
        this.errorMessageDetail = '';
      },

      close() {
        this.clearAllErrors();
        this.dialog = false;
      },

      async saveVacationCarryOverRequest(): Promise<void> {
        if (this.validateForm()) {
          this.clearAllErrors();
          this.loading = true;

          const vacationCarryOverRequestPayload = cloneDeep(
            this.vacationCarryOverRequest
          );

          try {
            if (this.isEdit) {
              const vacationCarryOverRequestDelta = diffDeep(
                vacationCarryOverRequestPayload,
                this.getVacationCarryOverRequestById(
                  vacationCarryOverRequestPayload.id
                ),
                true
              );

              await this.updateVacationCarryOverRequest(
                vacationCarryOverRequestDelta
              );
            } else {
              await this.createVacationCarryOverRequest(
                vacationCarryOverRequestPayload
              );
            }

            this.loading = false;
            this.close();
          } catch (err) {
            this.loading = false;
            const error = err as AxiosError;
            if (error.response) {
              if (error.response.data.detail) {
                this.errorMessageDetail = error.response.data.detail;
              }
              // client received an error response that falls out of range 2xx
              if (
                VacationCarryOverRequestFieldError.isVacationCarryOverRequestFieldError(
                  error.response.data
                )
              ) {
                this.fieldError = new VacationCarryOverRequestFieldError(
                  error.response.data
                );
              }
            }

            this.errorMessage = ErrorManager.extractApiError(error);
          }
        }
      }
    }
  });
